import Vue from "vue";
import VueRouter from "vue-router";
import { Message } from 'element-ui'
import store from '../store'
import { hasToken, getToken, clearAuth } from '../utils/auth'
import { validateToken, isTokenExpired } from '../utils/requests'
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    meta: { title: '智能问答', requireAuth: true },
    component: () => import('../views/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('../views/login/login.vue')
  },
  { path: '*', redirect: '/index' }
];

const router = new VueRouter({
  routes,
});

// 加上这一段，处理重复跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

/**
 * 令牌有效性校验（每次打开应用只做一次）
 * 结果缓存到 authChecked，避免每次路由切换都打一次接口。
 */
let authChecked = false
let authChecking = null

function ensureAuth() {
  if (authChecked) return Promise.resolve(true)
  if (authChecking) return authChecking

  authChecking = validateToken()
    .then(userInfo => {
      authChecked = true
      store.commit('setToken', getToken())
      if (userInfo) store.commit('setUserInfo', userInfo)
      return true
    })
    .catch(error => {
      authChecked = false
      // 只有明确失效（401 / 403 / 令牌业务码）才踢出；网络超时之类的抖动不误伤
      if (!isTokenExpired(error)) return true
      clearAuth()
      store.commit('clearUser')
      return false
    })
    .then(ok => {
      authChecking = null
      return ok
    })

  return authChecking
}

/** 登录成功后调用，让本次会话跳过重复校验 */
export function markAuthChecked() {
  authChecked = true
}

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title + ' - 智能体问答系统' : '智能体问答系统'

  // 没有令牌：需要鉴权的页面回登录页并带上回跳地址
  if (!hasToken()) {
    authChecked = false
    if (to.meta && to.meta.requireAuth) {
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }
    return next()
  }

  // 持有令牌访问登录页：只有确认令牌有效才挡回首页，失效则留在登录页重新登录
  if (to.path === '/login') {
    return ensureAuth().then(ok => (ok ? next({ path: '/index' }) : next()))
  }

  // 需求内页面：先静默确认令牌仍有效，通过才进 /index，失效才回登录页
  if (to.meta && to.meta.requireAuth) {
    return ensureAuth().then(ok => {
      if (ok) return next()
      Message.error('登录状态已失效，请重新登录')
      return next({ path: '/login', query: { redirect: to.fullPath } })
    })
  }

  next()
})

// 首次导航结束后移除首屏 loading（含守卫静默校验的等待时间）
router.afterEach(() => {
  removeBootLoading()
})

function removeBootLoading() {
  const el = document.getElementById('app-boot-loading')
  if (!el) return
  el.classList.add('boot-hide')
  setTimeout(() => {
    if (el.parentNode) el.parentNode.removeChild(el)
  }, 260)
}
// 兜底：守卫卡住或路由未就绪时也别一直挂着 loading
setTimeout(removeBootLoading, 8000)

export default router;
